<template>
  <component
    :is="messageComponent"
    :message="message"
    :has-next="hasNext"
    :same-minute="isWithinSameMinute">
    <component
      v-if="isBubble"
      :is="messageTypeComponent"
      :message="message"/>
  </component>
</template>

<script>
export default {
  components: {
    MessageAudio: () => import('@/components/message/MessageAudio.vue'),
    MessageBubble: () => import('@/components/message/MessageBubble.vue'),
    MessageDocument: () => import('@/components/message/MessageDocument.vue'),
    MessageImage: () => import('@/components/message/MessageImage.vue'),
    MessageLocation: () => import('@/components/message/MessageLocation.vue'),
    MessageNotification: () => import('@/components/message/MessageNotification.vue'),
    MessageSticker: () => import('@/components/message/MessageSticker.vue'),
    MessageText: () => import('@/components/message/MessageText.vue'),
    MessageTextTemplate: () => import('@/components/message/MessageTextTemplate.vue'),
    MessageVideo: () => import('@/components/message/MessageVideo.vue'),
  },
  props: {
    message: {
      required: true,
      type: Object,
    },
    hasNext: {
      default: false,
    },
    isWithinSameMinute: {
      default: false,
    },
  },
  computed: {
    isBubble() {
      return ['Client', 'User', 'UserSystem'].includes(this.message.typeUser);
    },
    messageComponent() {
      return this.isBubble ? 'message-bubble' : 'message-notification';
    },
    messageTypeComponent() {
      switch (this.message.type) {
        case 'text':
          return 'message-text';
        case 'image':
          return 'message-image';
        case 'video':
          return 'message-video';
        case 'audio':
        case 'voice':
          return 'message-audio';
        case 'document':
          return 'message-document';
        case 'location':
          return 'message-location';
        case 'tText':
          return 'message-text-template';
        case 'sticker':
          return 'message-sticker';
        default:
          return '';
      }
    },
  },
};
</script>
